import React from 'react';
import PropTypes from 'prop-types';
import features from 'lib/common/features';
import summaryTitle from 'lib/seats/summaryTitle';

const SeatView = props => {
    return (
        <div className="syos-seatview">
            <div className="syos-seatview__image">
                <img src={props.seatView.image} />
            </div>
            {(features.getOption('viewFromSeat', 'showCaption') === true) && (
                <div className="syos-seatview__caption">
                    Showing view for: {summaryTitle(props.seatView.data)}
                </div>
            )}
        </div>
    );
};
SeatView.propTypes = {
    seatView: PropTypes.object
}

export default SeatView



// WEBPACK FOOTER //
// ./src/javascripts/app/components/SeatView.js